/* Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */

export const Container = {
};

export const FormContainer = {

};

export const FormSection = {
};

export const FormField = {
};

export const SectionHeader = {
};

export const SectionBody = {
};

export const SectionFooter = {
};

export const SectionFooterPrimaryContent = {
};

export const SectionFooterSecondaryContent = {

};

export const Input = {
};

export const Button = {
};

export const SignInButton = {
};

export const SignInButtonIcon = {
};

export const SignInButtonContent = {
};

export const Strike = {
};

export const StrikeContent = {
};

export const ActionRow = {
};

export const FormRow = {
};

export const A = {
  cursor: 'pointer',
};

export const Hint = {
};

export const Radio = {
};

export const InputLabel = {

};

const Theme = {
  container: Container,
  formContainer: FormContainer,
  formSection: FormSection,
  formField: FormField,

  sectionHeader: SectionHeader,
  sectionBody: SectionBody,
  sectionFooter: SectionFooter,
  sectionFooterPrimaryContent: SectionFooterPrimaryContent,
  sectionFooterSecondaryContent: SectionFooterSecondaryContent,

  input: Input,
  button: Button,
  signInButton: SignInButton,
  signInButtonIcon: SignInButtonIcon,
  signInButtonContent: SignInButtonContent,
  formRow: FormRow,
  strike: Strike,
  strikeContent: StrikeContent,
  actionRow: ActionRow,
  a: A,

  hint: Hint,
  radio: Radio,
  inputLabel: InputLabel,
};

export default Theme;
